import { Box, SimpleGrid } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { RadioGroup, Select, YesNoRadioButton } from "components";
import SectionTitle from "pages/clients/view/components/section-title";
import { formClasses } from "styles";
import { CreditOptionsResponse } from "types";

interface BankCreditRequestMaritalProps {
  form: any;
  options: CreditOptionsResponse;
  visibleFields: string[];
  readOnly?: boolean;
}

export const BankCreditRequestMarital = ({
  form,
  options,
  visibleFields,
  readOnly = false,
}: BankCreditRequestMaritalProps) => {
  const { t } = useTranslation();

  return (
    <Box className={formClasses.sectionBorder}>
      <SectionTitle label={t("user.maritalStatus.label")} isBankCredit />
      <SimpleGrid cols={4}>
        <Select
          label={t("user.maritalStatus.label")}
          data={options["maritalStatus"].map((el) => ({
            value: el,
            label: t(`user.maritalStatus.options.${el}`),
          }))}
          key={form.key("maritalStatus")}
          {...form.getInputProps("maritalStatus")}
          clearable={true}
          required={true}
          disabled={readOnly}
        />
        {visibleFields.includes("partnerOnSameAddress") && (
          <YesNoRadioButton
            label={t("credit.partnerOnSameAddress.label")}
            name={"partnerOnSameAddress"}
            form={form}
            disabled={readOnly}
          />
        )}
        {visibleFields.includes("partnerResidence") && (
          <RadioGroup
            label={t("credit.partnerResidence.label")}
            fieldName="partnerResidence"
            options={[
              { value: "SWITZERLAND", label: t("credit.partnerResidence.options.SWITZERLAND") },
              { value: "ABROAD", label: t("credit.partnerResidence.options.ABROAD") },
            ]}
            form={form}
            disabled={readOnly}
          />
        )}
        {visibleFields.includes("partnerIncludeInApplication") && (
          <YesNoRadioButton
            label={t("credit.partnerIncludeInApplication.label")}
            name={"partnerIncludeInApplication"}
            form={form}
            disabled={readOnly}
          />
        )}
      </SimpleGrid>
    </Box>
  );
};
